import axios from 'axios';
import Config from '@/Config';

const host = Config.host + "PaymentsHosting/"


function getMyPayments(page = 0) {
  return axios.get(`${host}myLodgingPayment`, {
    params: { page: page }
  })
    .then(data => {
      return data.data
  })
}

function giftHosting(idCompany, idUser, months) {
  return axios.post(`${host}Gift`, {
    idCompany: idCompany,
    idUser: idUser,
    months: months
  }).then(response => {
    return response.data
  })
}

export default {
  getMyPayments,
  giftHosting
}